import { CountryData } from 'app/models/dto/country-data.model';

export class GetCountryData {
  static readonly type = '[CountryData] GetCountryData';
  constructor() { }
}

export class SelectCountry {
  static readonly type = '[CountryData] SelectCountry';
  constructor( public countryId: number) { }
}
